var map = {
	"./Dokhtar.png": 532,
	"./businessModel.png": 929,
	"./circle.png": 510,
	"./ecosystem.png": 930,
	"./sayLogo.png": 533,
	"./theNakama.png": 534,
	"./tokeneconomy.png": 931,
	"./transparency.png": 932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 928;